import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';

@Component({
  selector: 'app-new-property-use',
  templateUrl: '../../step/button-step/button-step.component.html',
  styleUrls: ['./property-use.component.scss', '../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class PropertyUseComponent extends ButtonStepComponent implements OnInit {
  title : string = "How do you use this property?";
  buttonList = [
    { text: 'Primary Home', value: 'primary', imageName: 'primary-home', default: true },
    { text: 'Secondary Home', value: 'secondary', imageName: 'secondary-home' },
    { text: 'Investment Property', value: 'investment', imageName: 'investment-property' },
  ];

  ngOnInit() {
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('propertyUse', this.control);
  }

  submit(button: any): void {
    super.submit(button);
  }
}
